// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_homepage_float_rightbar_app__18iiX"};